import { Injectable } from "@angular/core";
import { ApiResponse } from "../models/common.model";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Subject } from "rxjs";
import { LocalServiceService } from "./local-service.service";
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  public countOfExperiences: number = 0;
  public baseUrl = environment.baseUrlAdmin;

  // Common Data For reuse purpose
  public tagList: Array<any> = [];
  public regionList: Array<any> = [];
  public regionObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public subRegionLists: Array<any> = [];
  public subRegionAllRegionId: number = 0;
  public subRegionObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public userTagList: Array<any> = [];
  public subRegionListBaseProduct: Array<any> = [];
  public subRegionListBaseProductObserver: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]);
  public categoryList: BehaviorSubject<any> = new BehaviorSubject<Array<any>>([]); //Category List with Sub category
  public subCategoryList = [];
  // Common Data For reuse purpose

  public goBack() {
    const navCount = sessionStorage.getItem('navigationCount');
    if (navCount && Number(navCount) > 1) {
      console.log('going back', navCount);
      this.location.back();
    } else {
      this.router.navigate(['/community']);
    }

  }

  constructor(private http: HttpClient, private local: LocalServiceService, private location: Location, private router: Router) {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.getCommonRequireDataForLogInUser(true);
      }
    });
    this.getCommonRequireData();
  }

  public handleError(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/shop/default.png";
  }

  public handleBannerError(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/new/new-banner.webp";
  }

  public handleErrorUpload(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/uploadd2.png";
  }
  public handleErrorAvatar(event: any): void {
    (event.target as HTMLImageElement).src = "../../assets/images/w.jpeg";
  }

  public removeDuplicateAndCombineByProp(input: Array<any>, propName): Array<any> {
    let output: any = {};
    for (let i of input) {
      let filterItem = input?.filter((j) => j?.[propName] == i?.[propName]);
      if (filterItem.length > 1 && !output[i?.[propName]]) {
        i.id = filterItem?.map((i) => i.id);
        output[i[propName]] = i;
      } else if (!output[i?.[propName]]) {
        output[i?.[propName]] = filterItem;
      }
    }

    //@ts-ignore
    return Object.values(output)?.flat();
  }

  public uniqueById(arr) {
    if (arr && arr.length > 0) {
      return [...new Set(arr.map((item) => item.id))];
    } else {
      return [];
    }
  }

  public getCommonRequireData(Login: boolean = false) {
    this.http.get(`${this.baseUrl}getAllMemberSurveyInterest`).subscribe((resp: ApiResponse) => {
      this.tagList = resp.body;
    });

    this.http.get(`${this.baseUrl}getMemberShopSubRegion`).subscribe((resp: ApiResponse) => {
      this.subRegionObserver.next(structuredClone(resp.body));
      this.subRegionLists = resp.body.map((i: any) => {
        if (i.name.toLowerCase() == 'all') {
          this.subRegionAllRegionId = i?.subRegionId;
        }
        try {
          i["postalCode"] = Array.isArray(i["postalCode"]) ? i["postalCode"] : JSON.parse(i["postalCode"]) || [];
        } catch (e) {
          i["postalCode"] = [];
        }
        return i;
      });
      this.deepFreeze(this.subRegionLists);
    });

    this.http.get(`${this.baseUrl}getMemberShopSubRegionBaseOnProducts`).subscribe((resp: ApiResponse) => {
      this.subRegionListBaseProduct = resp.body;
      this.subRegionListBaseProductObserver.next(resp.body)
    });

    this.http.get(`${this.baseUrl}getMemberShopRegion`).subscribe((resp: ApiResponse) => {
      this.regionList = resp.body;
      this.regionObserver.next(resp.body);
    });

    this.http.get(`${this.baseUrl}getAllCategorieRelationship`).subscribe((resp: any) => {
      this.categoryList.next(resp.body);
      for (let i of resp.body) {
        this.subCategoryList = [...i.subCategory, ...this.subCategoryList];
      }
    });


  }


  public getCommonRequireDataForLogInUser(Login: boolean = false) {
    if (Login) {
      this.getTagList();
    }
  }

  public getCategoryName(id) {
    if (this.subCategoryList && id) {
      return this.subCategoryList.find((i: any) => i.categorieChildId == id)?.categoryName || "";
    }
  }

  public getSubregionName(id) {
    if (this.subRegionLists && id) {
      return this.subRegionLists.find((i: any) => i.subRegionId == id)?.name || "";
    }
  }

  public getSubregionId(name) {
    if (this.subRegionLists && name) {
      name = name.includes("|") ? name.split("|")[1] : name;
      return this.subRegionLists.find((i: any) => i.name.toLowerCase() == name.toLowerCase())?.subRegionId || "";
    }
  }

  public getTagList() {
    this.http.get(`${this.baseUrl}getSurveyResponses`).subscribe((resp: ApiResponse) => {
      let tags = [];
      let ignoreTag = "";
      for (let i of resp.body) {
        ignoreTag = i.ignoreTag;
        if (i?.question && i?.question["interest_name"] == "interest") {
          tags = [...tags, ...i?.selected_option];
        } else if (i?.question && i?.question?.answer_option == i?.selected_option?.selected) {
          tags = [...tags, i?.question?.interest_name];
        }
      }
      this.userTagList = tags.filter((i: any) => !ignoreTag?.includes(i));
    });
  }

  public getSubRegionBaseOnPostalCode(postalCode): any | null {
    if (postalCode && postalCode.length >= 2) {
      return this.subRegionLists.filter((subregion) => subregion.postalCode.includes(postalCode.slice(0, 2)))[0] || null;
    } else {
      return null;
    }
  }

  public deepFreeze(obj) {
    Object.freeze(obj);
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        this.deepFreeze(obj[key]);
      }
    });
  }

  public setTheme(theme: string) {
    localStorage.setItem("selectedTheme", theme);
    document.documentElement.classList.add(theme);
  }


  public clickButton(id: string) {
    const button = document.getElementById(id);
    if (button) {
      button.click();
    } else {
      console.error('button not found!')
    }
  }

  public correctSite(site: string) {
    if (site == 'null') {
      return ''
    }
    if (site?.trim()) {
      if (site?.startsWith('https') || site?.startsWith('http')) {
        return site
      }
      if (site?.startsWith('www')) {
        return 'https://' + site
      }
      return 'https://www.' + site

    }
    return ""

  }
}
